import React from 'react';
import globalConfig from 'react-global-configuration';
import { credentials } from '@shootsta/client-auth';
import identityReauthenticateRedirect from '../utils/identityAuthenticateRedirect';
import NotFound from '../../NotFound';
import NoOrganisations from '../../NoOrganisations';
import { AuthorisationContextConsumer } from '../context/AuthorisationContext';

import isPublicUrl from '../utils/isPublicUrl';







export default function AuthorisationConsumer({
  children,
  requiresOrganisation
}) {
  const MIN_PERMS = isPublicUrl() ? ['VIDEO_TOOL', 'VIDEO_REVIEW', 'CAST', 'ELEVATE'] : [];

  return (
    <AuthorisationContextConsumer>
      {(
      {
        organisationMemberships,
        isShootsta,
        isShootstaSeniorEditor,
        isShootstaEditor,
        isShootstaAdmin,
        isShootstaTechSupport,
        isShootstaAccountManager,
        isShootstaUser,
        isWorkspaceAdmin,
        selectedOrganisation: organisation,
        updateSelectedOrganisation,
        updateSelectedOrganisationData
      }) =>
      {
        const { user, auth } = credentials.get();
        const selectedOrganisation = organisation && organisation.organisationId ?
        organisation :
        { permissions: MIN_PERMS, includedAddonTypes: [], package: { amendmentsQuantity: 0 } };

        if (!requiresOrganisation) {
          return children({
            organisationMemberships: organisationMemberships || [],
            isShootsta,
            isShootstaSeniorEditor,
            isShootstaEditor,
            isShootstaAdmin,
            isShootstaTechSupport,
            selectedOrganisation,
            isShootstaAccountManager,
            isShootstaUser,
            isWorkspaceAdmin,
            updateSelectedOrganisation,
            updateSelectedOrganisationData
          });
        }

        const HIDE_FEATURES = globalConfig.get('HIDE_FEATURES') || {};
        if (!auth && !HIDE_FEATURES.LOGIN_VIA_IDENTITY) {
          identityReauthenticateRedirect();
          return null;
        }

        if (!user || !auth || auth && user.isAnonymous) {return <NotFound />;}

        if (!organisationMemberships || !organisationMemberships.length) {
          return <NoOrganisations />;
        }

        return children({
          organisationMemberships,
          isShootsta,
          isShootstaSeniorEditor,
          isShootstaEditor,
          isShootstaAdmin,
          isShootstaTechSupport,
          selectedOrganisation,
          isShootstaAccountManager,
          isShootstaUser,
          isWorkspaceAdmin,
          updateSelectedOrganisation,
          updateSelectedOrganisationData
        });
      }}
    </AuthorisationContextConsumer>);

}